<template>
    <div style="height:100%">
        <!-- loading组件 -->
        <div v-if="loading"
             class="custom-loading"
             style="height:100%">
            <loading :size='24'></loading>
        </div>
        <div v-show="!loading"
             class="login-container">
            <div class="header">
                <div class="header-div">
                    <img @click="openUrl"
                         :src="syslogo">
                    <!-- 语言切换 -->
                    <Dropdown trigger="click"
                              class="dropdown"
                              placement="bottom-end"
                              @on-click="handleLanguage"
                              style="margin-left:20px;">
                        <a class="i18n-area"
                           href="javascript:void(0)">
                            <span>{{language === 'zh-CN' ? $t('简体中文') : 'English'}}</span>
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <DropdownMenu slot="list">
                            <DropdownItem name="zh-CN"
                                          v-if="language === 'en-US'"> {{$t('简体中文')}} </DropdownItem>
                            <DropdownItem name="en-US"
                                          v-if="language === 'zh-CN'"> English </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                    <!-- 支持 -->
                    <Dropdown trigger="click"
                              class="dropdown"
                              placement="bottom-end"
                              @on-click="handleDropdown">
                        <a class="support"
                           href="javascript:void(0)">
                            <span>{{$t('支持')}}</span>
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <DropdownMenu slot="list">
                            <DropdownItem>
                                <i class="icon-phone-o mar-right15"></i>{{appContactNumber}}
                            </DropdownItem>
                            <DropdownItem divided>
                                <span :title="appVersion.split('-')[0]">&nbsp;&nbsp;{{$t('版本号')}}：{{appVersion.split("-")[0]}}</span>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
            <div class="login-div">
                <div class="login-position">
                    <div class="login-form-div">
                        <div class="title">{{$t('密码登录')}}</div>
                        <!-- 密码登陆 -->
                        <div class="login-form"
                             @keydown.enter="handleSubmit">
                            <Form ref="pwdForm"
                                  :model="pwdForm"
                                  :rules="ruleInline">
                                <FormItem prop="account"
                                          style="margin-bottom:22px">
                                    <Input type="text"
                                           size="large"
                                           v-model.trim="pwdForm.account"
                                           autofocus
                                           :placeholder="$t('手机邮箱用户名')">
                                    <Icon type="ios-person-outline"
                                          slot="prefix">
                                    </Icon>
                                    </Input>
                                </FormItem>
                                <FormItem prop="password"
                                          style="margin-bottom:22px;">
                                    <Input type="password"
                                           size="large"
                                           v-model.trim="pwdForm.password"
                                           :placeholder="$t('密码')">
                                    <Icon type="ios-lock-outline"
                                          slot="prefix"></Icon>
                                    </Input>
                                </FormItem>
                                <!-- 验证码 -->
                                <FormItem v-if="isCaptcha != 'false' && verifyIndex"
                                          :style="{marginBottom: errorInfo != null ? '0':'14px'}">
                                    <Verify ref="rcverify"
                                            :type="1"
                                            :codeLength="4"
                                            width="84px"
                                            height="36px"
                                            fontSize="16px"
                                            @success="verify('success')"
                                            @error="verify('error')"></Verify>
                                </FormItem>
                                <FormItem v-if="errorInfo != null"
                                          style="margin:0px;">
                                    <span style="color:#ed4014;float:left">{{$t(errorInfo)}}</span>
                                </FormItem>
                                <FormItem style="margin-bottom:14px;">
                                    <Button type="primary"
                                            :loading="logining"
                                            @click="handleSubmit"
                                            long>{{$t('登录')}}</Button>
                                </FormItem>
                            </Form>
                        </div>
                        <!-- 操作 -->
                        <div class="actions">
                            <router-link to="/register"
                                         v-show="isShowRegister">{{$t('立即注册')}}</router-link>
                            <router-link to="/retrieve"
                                         style="float: right">{{$t('忘记密码')}}?</router-link>
                        </div>
                    </div>
                    <div class="footer">
                        <span>{{companyname}}</span>&nbsp;&nbsp;<span>{{copyright}}</span>
                    </div>
                </div>

            </div>
            <!--ccportal-->
            <form id="loginForm"
                  class="login-form"
                  :action="params.ccPortalUrl"
                  method="post"
                  style="height: 0px;overflow: hidden;opacity: 0;">
                <input type="text"
                       :value="params.username"
                       class="hide-input"
                       name="username" />
                <input type="password"
                       :value="params.password"
                       class="hide-input"
                       name="password" />
                <input type="submit"
                       value="Submit"
                       onclick="ccLogin">
            </form>
        </div>
    </div>
</template>

<script>
import { setTimeout } from 'timers'
import { Base64 } from 'js-base64'
import Verify from '@/views/components/basic/iverify/dsverify.vue'
import API from '@/service/api.js'
import locale from '@/locale/locale'
import iviewI18n from '@/locale/iview_i18n.js'
import loading from '@c/basic/loading'
import {
    deleteCookie
} from '@/service/utils'
import { mapState } from 'vuex'
export default {
    name: 'login',
    components: {
        Verify,
        loading
    },
    data () {
        return {
            loading: true,
            companyname: '',
            copyright: '',
            logining: false,
            errorInfo: null,
            verifyFlag: false, // 验证码验证结果
            verifyIndex: false, // 是否显示验证码，第一次不显示，登录失败才显示
            pwdForm: {
                account: '',
                password: ''
            },
            params: {
                ccPortalUrl: null,
                username: null,
                password: null
            },
            ruleInline: {
                account: [
                    {
                        required: true,
                        message: this.$t('请填写用户名'),
                        trigger: 'submit'
                    }
                ],
                password: [
                    {
                        required: true,
                        message: this.$t('请填写密码'),
                        trigger: 'submit'
                    }
                ]
            }
        }
    },
    computed: {
        ...mapState({
            sysLogo: state => state.app.appConfig.sysLogo || ''
        }),
        isShowRegister () { // 是否放开注册
            return this.$store.state.app.appConfig.isRegister
        },
        appVersion () { // 系统版本
            return this.$store.state.app.appConfig.version
        },
        appContactNumber () { // 系统联系号码
            return this.$store.state.app.appConfig.appContactNumber
        },
        isCaptcha () { // 验证码
            return this.$store.state.app.appConfig.isCaptcha
        },
        loginBackground () { // 登录背景图
            return this.$store.state.app.appConfig.loginBg
        },
        getPortalUrl () {
            return '/'
        },
        language () {
            return this.$store.state.app.appConfig.language
        }
    },
    watch: {
        'pwdForm.account': function (val, oldVal) {
            this.errorInfo = null
        },
        'pwdForm.password': function (val, oldVal) {
            this.errorInfo = null
        }
    },
    created () {
        this.$logout()
        this.getPortalOem()
        // 路径参数cc=true，表示ccPortal登录过期。运营平台退出登陆
        const status = this.getUrlParam('cc')
        if (status.indexOf('true') !== -1 && this.$store.state.app.isLogined) {
            this.logout()
        }
    },
    methods: {
        getPortalOem () {
            this.axios.get(this.urlFormat(API.GET_PORTAL_OEM, true), {
                headers: {
                    noAuth: true
                }
            }).then(res => {
                this.companyname = 'Copyright ©' + res.companyName
                this.copyright = res.preparedNumber || ''
            })
        },
        getQueryString (name) {
            var queryString = document.referrer.substring(document.referrer.indexOf('?') + 1)
            var parameters = queryString.split('&')
            var pos, paraName, paraValue
            for (var i = 0; i < parameters.length; i++) {
                // 获取等号位置
                pos = parameters[i].indexOf('=')
                if (pos === -1) { continue }

                // 获取name 和 value
                paraName = parameters[i].substring(0, pos)
                paraValue = parameters[i].substring(pos + 1)

                // 如果查询的name等于当前name，就返回当前值，同时，将链接中的+号还原成空格
                if (paraName === name) {
                    return unescape(paraValue.replace(/\+/g, ' '))
                }
            }
        },
        handleSubmit () {
            sessionStorage.removeItem('resourcesEnvId')// 清除云资源的云环境Id
            this.logining = true
            this.$refs.pwdForm.validate((valid) => {
                if (valid) {
                    if (this.isCaptcha !== 'false' && this.verifyIndex && !this.verifyFlag) {
                        this.errorInfo = '验证码错误'
                        this.logining = false
                    } else {
                        this.verifyFlag = false
                        this.login({
                            account: this.pwdForm.account.trim(),
                            password: Base64.encode(this.pwdForm.password).trim(),
                            moduleType: 'console',
                            userType: '03'
                        })
                    }
                } else {
                    // 错误提示
                    this.logining = false
                }
            })
        },
        async login (params, requestQuery) {
            const res = await this.postLogin(params, requestQuery)
            if (res && res.status && res.status !== 'false') {
                this.$store.commit('setAppCookie', res.token)
                //  获取用户信息
                await this.getUserInfoByToken()
                // 路径参数cc=true，表示ccPortal登录过期。需重新登录
                const status = this.getUrlParam('cc')
                if (status.indexOf('true') !== -1) {
                    // 获取ccPortal用户名，密码
                    this.getUser()
                }
                const redirect = this.$route.query.redirect
                const routes = this.$store.state.user.currentUser.routes
                setTimeout(() => {
                    if (redirect && !['403'].includes(routes.router)) {
                        if (this.$store.state.user.currentUser.isBssAdmin) {
                            if (this.$store.state.user.currentUser.moduleType === 'bss') {
                                this.$router.push({ path: this.$store.state.user.currentUser.routes.router })
                            } else {
                                window.location.href = this.$store.state.app.url.ConsoleUrl + this.$store.state.user.currentUser.routes.router
                            }
                        } else {
                            // redirect 登录后跳转地址，由登录鉴权控制
                            this.$router.push({ path: redirect || '/' })
                        }
                    } else {
                        if (document.referrer && document.referrer.length > 0 && this.getQueryString('applyId')) {
                            // 跳转产品购买页面
                            this.$router.push({ path: '/apply/' + this.getQueryString('applyId') })
                        } else {
                            this.$router.push({ path: routes.router || '/' })
                        }
                    }
                }, 3000)
            } else {
                // 验证码刷新
                this.verifyIndex = false
                // 手动刷新code
                setTimeout(() => {
                    this.verifyIndex = true
                }, 100)
                this.errorInfo = res.message
            }
            setTimeout(() => {
                this.logining = false
            }, 3000)
        },
        // 登陆请求发送
        postLogin (params, requestQuery) {
            return this.axios.post(this.urlFormat(API.LOGIN, true), params, {
                headers: {
                    // noAuth: true,
                    showMsg: false
                }
            })
        },
        // 获取url中的参数值
        getUrlParam (name) {
            let str = ''
            const arr = (window.location.href).split('?')
            const data = arr.length > 1 ? (arr[1].split('&')) : null
            for (const i in data) {
                const subdata = data[i].split('=')
                if (subdata[0] === name) {
                    str = subdata[1]
                }
            }
            return str
        },
        // 退出平台
        logout () {
            this.axios.post(this.urlFormat(API.LOGOUT, true)).then(res => {
                if (res) {
                    // 断开websocket连接
                    const socketClient = this.$store.state.app.rcSocketClient
                    if (socketClient && socketClient.connected) {
                        socketClient.disconnect(() => {
                            console.warn('>> WebSocket断开连接.')
                        })
                    }
                    // 删除token
                    deleteCookie('PLATFORM_CMP_TOKEN', this.$store.state.app.url.Domain)
                    deleteCookie('PLATFORM_CMP_TOKEN', this.$store.state.app.url.PortalUrl)
                    // 删除usersid
                    deleteCookie('USERSID', this.$store.state.app.url.Domain)
                    // 删除setSubject
                    deleteCookie('SUBJECT', this.$store.state.app.url.Domain)
                    this.$store.state.app.isLogined = false
                    // 暴力删除window中遗留的定时器
                    for (let i = 0; i < 10; i++) {
                        window.clearInterval(i)
                    }
                }
            })
        },
        // 获取ccPortal用户名，密码
        getUser () {
            this.axios.get(this.urlFormat(API.GET_CCPORTAL_INFO, false)).then(res => {
                this.params = {
                    ccPortalUrl: res.ccPortalUrl,
                    username: res.userId,
                    password: this.$decrypt(res.userPwd)
                }
                this.$nextTick(() => {
                    if (this.params !== null && this.params.username && this.params.password) {
                        // ccPortal登录
                        this.ccLogin()
                    }
                })
            })
        },
        // ccPortal登录
        ccLogin () {
            document.getElementById('loginForm').submit()
        },
        // 设置用户信息
        async getUserInfoByToken () {
            const params = { moduleType: 'console' }
            const result = await this.axios.get(this.urlFormat(API.TOKEN, true), { params })
            this.$store.commit('setUserData', result)
        },
        handleDropdown (name) {
            // TODO 帮助文档
        },
        openUrl () {
            this.$router.push({ path: '/' })
        },
        verify (type) {
            if (type === 'success') {
                this.verifyFlag = true
            } else {
                this.verifyFlag = false
            }
        },
        rcCallBack () {
            const result = { flag: false, route: null }
            const callbackUrl = sessionStorage.getItem('rc_callback')
            if (callbackUrl) {
                const callback = callbackUrl.split('&')
                // TODO 先不判断权限
                result.flag = true
                result.route = callback[0]
                // if (callback[1] === 'all' || inOfArray(this.$store.state.user.currentUser.permissions, callback[1])) {
                //     result.flag = true
                //     result.route = callback[0]
                // }
            }
            return result
        },
        handleLanguage (val) {
            localStorage.setItem('lang', val)
            this.$store.commit('setOtherConfig', { language: val })
            const messages = Object.assign(locale[val], iviewI18n[val])
            // 设置数据
            this.$i18n.setLocaleMessage(val, messages)
            // 切换语言
            this.$i18n.locale = val
        }
    }
}
</script>

<style lang="less">
.dropdown {
    .ivu-select-dropdown {
        top: 44px !important;
    }
}
</style>
<style lang="less" scoped>
.login-container {
    width: 100%;
    height: 100%;
    .header {
        margin: 0 auto;
        background: #2a303c;
        height: 46px;
        .header-div {
            width: 100%;
            height: 46px;
            line-height: 46px;
            padding: 0 30px;
            margin: 0 auto;
            color: white;
            img {
                width: 160px;
                margin: 0;
                vertical-align: middle;
                cursor: pointer;
            }
            .dropdown {
                float: right;
                color: #ffffff;
                .i18n-area {
                    float: right;
                    font-size: 14px;
                    cursor: pointer;
                    color: #ddd;
                }
                .support {
                    float: right;
                    font-size: 14px;
                    cursor: pointer;
                    color: #ddd;
                }
                .support:hover {
                    color: #57a3f3;
                }
            }
        }
    }
    .login-div {
        width: 100%;
        height: calc(~'100% - 46px');
        // height: calc(~"100% - 180px");
        background-image: url('/images/background.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: relative;
        .login-position {
            position: relative;
            width: 1170px;
            margin: 0 auto;
            height: 100%;
            display: table;
            .login-form-div {
                position: absolute;
                top: 47%;
                right: 0;
                transform: translateY(-50%);
                width: 320px;
                padding: 10px 45px 45px 45px;
                background: #fff;
                box-shadow: 0 1px 6px rgba(3, 3, 3, 0.2);
                // border-radius: 3px;
                .login-type-icon {
                    position: absolute;
                    left: 0;
                    top: 0;
                }
                .title {
                    text-align: center;
                    margin-top: 20px;
                    font-size: 20px;
                    margin-bottom: 30px;
                    color: #000;
                }
                .qrcode-cont {
                    position: relative;
                    margin: 0 auto;
                    width: 240px;
                    height: 240px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                    .qrcode-model {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(255, 255, 255, 0.9);
                    }
                }
                .empty-phone-msg {
                    position: absolute;
                    left: 0;
                    top: 100%;
                    height: 20px;
                    line-height: 20px;
                    color: red;
                    font-size: 12px;
                }
                .actions {
                    margin: 10px 0 15px;
                    height: 20px;
                    a {
                        line-height: 20px;
                        color: #333;
                        font-size: 12px;
                    }
                }
                .login-way {
                    img {
                        margin-left: 10px;
                        width: 26px;
                        height: 26px;
                        vertical-align: middle;
                    }
                }
            }
        }
    }
    .footer {
        padding: 30px 0;
        text-align: center;
        line-height: 30px;
        color: #666666;
        border-top: 1px solid #e3e3e3;
        width: 1170px;
        margin: 0 auto;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }
}
</style>
